import styled from "styled-components";

export const CssHome = styled.div`
	width: 100%;
	background: #ff0b05;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= GERAL ========================= */

	.caseHero {
		width: 100%;
		min-height: 480px;
		background: #ff0b05;
		position: relative;
		margin-top: 75px;
		overflow: hidden;
	}

	.caseContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 480px;
		margin: 0 auto;
		position: relative;
		 padding: 2% 4%;
		box-sizing: border-box;
	}

	

	/* ========================= PARTE 1 ========================= */

	.transmissaoHeroContent {
		width: 100%;
		min-height: 360px;
		position: relative;
		z-index: 2;
	}

	.transmissaoLogo {
		width: 270px;
		max-width: 28vw;
		height: auto;
		display: block;
		position: absolute;
		left: 0;
		top: 95px;
		z-index: 3;
	}

	.transmissaoText {
		width: 100%;
		max-width: 650px;
		position: absolute;
		right: 0;
		bottom: 0;
		z-index: 3;
		color: #2befff;
		font-size: 20px;
		line-height: 1.45;
		font-weight: 400;
		letter-spacing: 0;
		text-align: center;
		text-transform: none;
	}

	.transmissaoText p {
		margin: 0;
	}

	.transmissaoText strong {
		color: #d9f7ff;
	}

	.transmissaoVectorZ {
		width: 180px;
		height: auto;
		display: block;
		position: absolute;
		right: 0;
		top: 58px;
		z-index: 3;
	}

	.animLogoLeft {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animTextBottom {
		opacity: 0;
		transform: translateY(90px);
		transition: opacity 0.85s ease 0.25s, transform 0.85s ease 0.25s;
	}

	.animVectorRight {
		opacity: 0;
		transform: translateX(120px);
		transition: opacity 0.85s ease 0.5s, transform 0.85s ease 0.5s;
	}

	.animateParte1 .animLogoLeft,
	.animateParte1 .animTextBottom,
	.animateParte1 .animVectorRight {
		opacity: 1;
		transform: translate(0, 0);
	}

	/* ========================= PARTE 2 ========================= */

	.transmissaoCapaSection {
		width: 100%;
		background: #000;
		position: relative;
		overflow: hidden;
		padding: 0;
		margin: 0;
	}

	.transmissaoCapaWrap {
		width: 100%;
		position: relative;
		overflow: hidden;
	}

	.transmissaoCapa {
		width: 100%;
		height: auto;
		display: block;
	}

	.animCapaBottom {
		opacity: 0;
		transform: translateY(140px);
		transition: opacity 0.9s ease, transform 0.9s ease;
	}

	.animateParte2 .animCapaBottom {
		opacity: 1;
		transform: translateY(0);
	}

	/* ========================= RESPONSIVO - PARTE 1 ========================= */

	@media (max-width: 1366px) {
		.caseContainer {
			max-width: 1080px;
			padding: 42px 0 45px;
		}
	}

	@media (max-width: 1100px) {
		.caseContainer {
			width: calc(100% - 80px);
		}

		.transmissaoLogo {
			width: 250px;
		}

		.transmissaoVectorZ {
			width: 160px;
		}

		.transmissaoText {
			max-width: 590px;
			font-size: 19px;
		}
	}

	@media (max-width: 768px) {
		.caseHero {
			min-height: 560px;
			margin-top: 70px;
		}

		.caseContainer {
			width: calc(100% - 52px);
			min-height: 560px;
			padding: 32px 0 45px;
		}

		.caseNav {
			font-size: 18px;
		}

		.transmissaoHeroContent {
			min-height: 440px;
		}

		.transmissaoLogo {
			width: 265px;
			max-width: 78vw;
			left: 0;
			top: 80px;
		}

		.transmissaoVectorZ {
			width: 135px;
			right: 0;
			top: 205px;
		}

		.transmissaoText {
			max-width: 100%;
			right: 0;
			bottom: 0;
			font-size: 18px;
			line-height: 1.42;
			text-align: center;
		}
	}

	@media (max-width: 520px) {
		.caseHero {
			min-height: 520px;
		}

		.caseContainer {
			width: calc(100% - 36px);
			min-height: 520px;
			padding: 28px 0 40px;
		}

		.caseNav {
			font-size: 16px;
		}

		.caseNav img {
			width: 13px;
		}

		.transmissaoHeroContent {
			min-height: 410px;
		}

		.transmissaoLogo {
			width: 230px;
			top: 72px;
		}

		.transmissaoVectorZ {
			width: 105px;
			top: 205px;
		}

		.transmissaoText {
			font-size: 16px;
			line-height: 1.4;
		}

		.animLogoLeft {
			transform: translateX(-70px);
		}

		.animTextBottom {
			transform: translateY(60px);
		}

		.animVectorRight {
			transform: translateX(70px);
		}
	}

	/* ========================= RESPONSIVO - PARTE 2 ========================= */

	@media (max-width: 768px) {
		.transmissaoCapa {
			width: 130%;
			max-width: none;
			margin-left: -15%;
		}
	}

	@media (max-width: 520px) {
		.transmissaoCapa {
			width: 165%;
			margin-left: -32%;
		}

		.animCapaBottom {
			transform: translateY(90px);
		}
	}
`;

export const CssQuadro = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= PARTE 2 - QUADRO ========================= */

	.quadroSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
		padding: 70px 0 0;
		box-sizing: border-box;
	}

	.quadroContainer {
		width: 100%;
		position: relative;
		overflow: hidden;
	}

	.quadroTexto {
		width: 100%;
		max-width: 900px;
		margin: 0 auto 34px;
		color: #111;
		font-size: 18px;
		line-height: 1.55;
		font-weight: 500;
		text-align: center;
		position: relative;
		z-index: 3;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.quadroTexto p {
		margin: 0;
	}

	.quadroImg {
		width: 115%;
		max-width: none;
		height: auto;
		display: block;
		margin-left: -7.5%;
		position: relative;
		z-index: 2;
		transform-origin: center top;
	}

	.animQuadroTexto {
		opacity: 0;
		transform: translateY(80px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animQuadroImg {
		opacity: 0;
		transform: translateY(-120px);
		transition: opacity 0.95s ease 0.28s, transform 0.95s ease 0.28s;
	}

	.animateQuadro .animQuadroTexto {
		opacity: 1;
		transform: translateY(0);
	}

	.animateQuadro .animQuadroImg {
		opacity: 1;
		transform: translateY(0);
	}

	/* ========================= RESPONSIVO - PARTE 2 ========================= */

	@media (max-width: 1366px) {
		.quadroSection {
			padding-top: 64px;
		}

		.quadroTexto {
			max-width: 840px;
			font-size: 17px;
			margin-bottom: 30px;
		}

		.quadroImg {
			width: 118%;
			margin-left: -9%;
		}
	}

	@media (max-width: 1100px) {
		.quadroTexto {
			max-width: 760px;
			font-size: 16px;
		}

		.quadroImg {
			width: 130%;
			margin-left: -15%;
		}
	}

	@media (max-width: 768px) {
		.quadroSection {
			padding-top: 52px;
		}

		.quadroTexto {
			max-width: 92%;
			font-size: 15px;
			line-height: 1.5;
			margin-bottom: 26px;
			padding: 0;
		}

		.quadroImg {
			width: 160%;
			margin-left: -30%;
		}

		.animQuadroTexto {
			transform: translateY(60px);
		}

		.animQuadroImg {
			transform: translateY(-80px);
		}
	}

	@media (max-width: 520px) {
		.quadroSection {
			padding-top: 42px;
		}

		.quadroTexto {
			max-width: 88%;
			font-size: 14px;
			line-height: 1.45;
			margin-bottom: 22px;
		}

		.quadroImg {
			width: 210%;
			margin-left: -55%;
		}
	}
`;

export const CssSuvinil = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= PARTE 4 - SUVINIL ========================= */

	.suvinilSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
		padding: 70px 0;
		box-sizing: border-box;
	}

	.suvinilContainer {
		width: 100%;
		max-width: 1440px;
		height: 780px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
	}

	.suvinilTexto {
		width: 100%;
		max-width: 520px;
		position: absolute;
		left: 9%;
		top: 0;
		z-index: 7;
		color: #003846;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.02em;
	}

	.suvinilTexto p {
		margin: 0;
	}

	.suvinilStat {
		position: absolute;
		z-index: 8;
		display: flex;
		flex-direction: column;
		align-items: center;
		line-height: 1;
	}

	.suvinilStat strong {
		display: block;
		color: #e10000;
		font-size: 98px;
		line-height: 0.92;
		font-weight: 800;
		letter-spacing: -0.08em;
	}

	.suvinilStat span {
		display: block;
		margin-top: 8px;
		color: #222;
		font-size: 15px;
		line-height: 1.2;
		font-weight: 400;
		letter-spacing: -0.04em;
	}

	.suvinilStat150 {
		left: 12.5%;
		top: 148px;
	}

	.suvinilStat100 {
		right: 15.5%;
		bottom: 56px;
	}

	.suvinilCard {
		display: block;
		position: absolute;
		object-fit: cover;
		z-index: 5;
		box-sizing: border-box;
	}

	.suvinilCardLeft {
		z-index: 5;
	}

	.suvinilCardRight {
		z-index: 6;
	}

	.suvinilCard1 {
		width: 225px;
		height: 190px;
		left: 7.5%;
		top: 312px;
	}

	.suvinilCard2 {
		width: 225px;
		height: 190px;
		left: 27.2%;
		top: 312px;
	}

	.suvinilCard3 {
		width: 225px;
		height: 185px;
		left: 7.5%;
		top: 515px;
	}

	.suvinilCard4 {
		width: 300px;
		height: 185px;
		left: 27.2%;
		top: 515px;
	}

	.suvinilCard5 {
		width: 300px;
		height: 180px;
		right: 23.7%;
		top: 180px;
	}

	.suvinilCard6 {
		width: 210px;
		height: 180px;
		right: 8.2%;
		top: 180px;
	}

	.suvinilCard7 {
		width: 240px;
		height: 170px;
		right: 25.9%;
		top: 376px;
	}

	.suvinilCard8 {
		width: 255px;
		height: 170px;
		right: 8.2%;
		top: 376px;
	}

	.suvinilCelular {
		width: 320px;
		height: auto;
		display: block;
		position: absolute;
		left: 50%;
		top: 90px;
		transform: translateX(-50%);
		z-index: 10;
		filter: drop-shadow(0 10px 14px rgba(0, 0, 0, 0.3));
	}

	.suvinilVectorAzul {
		width: 515px;
		height: auto;
		display: block;
		position: absolute;
		right: -14px;
		top: 74px;
		z-index: 2;
	}

	.suvinilVetorVazado {
		width: 240px;
		height: auto;
		display: block;
		position: absolute;
		right: 0;
		top: 24px;
		z-index: 4;
	}

	/* ========================= ANIMAÇÕES - SUVINIL ========================= */

	.animSuvinilTextLeft {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animSuvinilCard1 {
		opacity: 0;
		transform: translateX(-120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.animSuvinilCard2 {
		opacity: 0;
		transform: translateX(120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.animSuvinilVector {
		opacity: 0;
		transform: translateX(160px);
		transition-property: opacity, transform;
		transition-duration: 0.85s;
		transition-timing-function: ease;
	}

	.animSuvinilCelular {
		opacity: 0;
		transform: translateX(-50%) translateY(130px);
		transition: opacity 0.95s ease 2.95s, transform 0.95s ease 2.95s;
	}

	.animSuvinilStat150 {
		opacity: 0;
		transform: translateX(-140px);
		transition: opacity 0.85s ease 3.55s, transform 0.85s ease 3.55s;
	}

	.animSuvinilStat100 {
		opacity: 0;
		transform: translateX(140px);
		transition: opacity 0.85s ease 3.85s, transform 0.85s ease 3.85s;
	}

	.suvinilCard1A {
		transition-delay: 0.35s;
	}

	.suvinilCard1B {
		transition-delay: 0.55s;
	}

	.suvinilCard1C {
		transition-delay: 0.75s;
	}

	.suvinilCard1D {
		transition-delay: 0.95s;
	}

	.suvinilCard2A {
		transition-delay: 1.25s;
	}

	.suvinilCard2B {
		transition-delay: 1.45s;
	}

	.suvinilCard2C {
		transition-delay: 1.65s;
	}

	.suvinilCard2D {
		transition-delay: 1.85s;
	}

	.suvinilVectorAzul.animSuvinilVector {
		transition-delay: 2.25s;
	}

	.suvinilVetorVazado.animSuvinilVector {
		transition-delay: 2.45s;
	}

	.animateSuvinil .animSuvinilTextLeft,
	.animateSuvinil .animSuvinilCard1,
	.animateSuvinil .animSuvinilCard2,
	.animateSuvinil .animSuvinilVector,
	.animateSuvinil .animSuvinilStat150,
	.animateSuvinil .animSuvinilStat100 {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateSuvinil .animSuvinilCelular {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}

	/* ========================= RESPONSIVO - SUVINIL ========================= */

	@media (max-width: 1366px) {
		.suvinilContainer {
			max-width: 1180px;
			height: 690px;
		}

		.suvinilTexto {
			left: 6%;
			max-width: 470px;
			font-size: 17px;
		}

		.suvinilStat strong {
			font-size: 84px;
		}

		.suvinilStat span {
			font-size: 19px;
		}

		.suvinilStat150 {
			left: 11%;
			top: 138px;
		}

		.suvinilStat100 {
			right: 14%;
			bottom: 42px;
		}

		.suvinilCelular {
			width: 285px;
			top: 90px;
		}

		.suvinilCard1 {
			width: 190px;
			height: 160px;
			left: 5%;
			top: 292px;
		}

		.suvinilCard2 {
			width: 190px;
			height: 160px;
			left: 22%;
			top: 292px;
		}

		.suvinilCard3 {
			width: 190px;
			height: 155px;
			left: 5%;
			top: 464px;
		}

		.suvinilCard4 {
			width: 250px;
			height: 155px;
			left: 22%;
			top: 464px;
		}

		.suvinilCard5 {
			width: 245px;
			height: 150px;
			right: 23%;
			top: 170px;
		}

		.suvinilCard6 {
			width: 170px;
			height: 150px;
			right: 7%;
			top: 170px;
		}

		.suvinilCard7 {
			width: 200px;
			height: 145px;
			right: 25.2%;
			top: 334px;
		}

		.suvinilCard8 {
			width: 210px;
			height: 145px;
			right: 7%;
			top: 334px;
		}

		.suvinilVectorAzul {
			width: 420px;
			top: 72px;
			right: -12px;
		}

		.suvinilVetorVazado {
			width: 205px;
			top: 20px;
		}
	}

	@media (max-width: 1100px) {
		.suvinilSection {
			padding: 60px 0;
		}

		.suvinilContainer {
			width: 100%;			
		}

		.suvinilTexto {
			left: 3%;
			max-width: 420px;
			font-size: 15px;
		}

		.suvinilStat strong {
			font-size: 70px;
		}

		.suvinilStat span {
			font-size: 17px;
		}

		.suvinilStat150 {
			left: 9%;
			top: 128px;
		}

		.suvinilStat100 {
			right: 12%;
			bottom: 34px;
		}

		.suvinilCelular {
			width: 300px;
			top: 96px;
		}

		.suvinilCard1 {
			width: 150px;
			height: 128px;
			left: 3%;
			top: 268px;
		}

		.suvinilCard2 {
			width: 150px;
			height: 128px;
			left: 18.5%;
			top: 268px;
		}

		.suvinilCard3 {
			width: 150px;
			height: 124px;
			left: 3%;
			top: 406px;
		}

		.suvinilCard4 {
			width: 205px;
			height: 124px;
			left: 18.5%;
			top: 406px;
		}

		.suvinilCard5 {
			width: 200px;
			height: 124px;
			right:18%;
			top: 168px;
		}

		.suvinilCard6 {
			width: 140px;
			height: 124px;
			right: 3%;
			top: 168px;
		}

		.suvinilCard7 {
			width: 162px;
			height: 116px;
			right: 21%;
			top: 304px;
		}

		.suvinilCard8 {
			width: 175px;
			height: 116px;
			right: 3%;
			top: 304px;
		}

		.suvinilVectorAzul {
			width: 355px;
			top: 75px;
		}

		.suvinilVetorVazado {
			width: 175px;
			top: 16px;
		}
	}

	@media (max-width: 768px) {
		.suvinilSection {
			padding: 48px 0;
		}

		.suvinilContainer {
			width: calc(100% - 24px);
			height: 500px;
		}

		.suvinilTexto {
			left: 2%;
			top: 0;
			max-width: 330px;
			font-size: 12px;
			line-height: 1.35;
		}

		.suvinilStat strong {
			font-size: 48px;
		}

		.suvinilStat span {
			margin-top: 4px;
			font-size: 12px;
		}

		.suvinilStat150 {
			left: 8%;
			top: 104px;
		}

		.suvinilStat100 {
			right: 11%;
			bottom: 28px;
		}

		.suvinilCelular {
			width: 190px;
			top: 96px;
		}

		.suvinilCard1 {
			width: 104px;
			height: 88px;
			left: 2%;
			top: 226px;
		}

		.suvinilCard2 {
			width: 104px;
			height: 88px;
			left: 17.5%;
			top: 226px;
		}

		.suvinilCard3 {
			width: 104px;
			height: 86px;
			left: 2%;
			top: 322px;
		}

		.suvinilCard4 {
			width: 142px;
			height: 86px;
			left: 17.5%;
			top: 322px;
		}

		.suvinilCard5 {
			width: 138px;
			height: 86px;
			right: 22%;
			top: 154px;
		}

		.suvinilCard6 {
			width: 96px;
			height: 86px;
			right: 2%;
			top: 154px;
		}

		.suvinilCard7 {
			width: 112px;
			height: 80px;
			right: 25%;
			top: 248px;
		}

		.suvinilCard8 {
			width: 120px;
			height: 80px;
			right: 2%;
			top: 248px;
		}

		.suvinilVectorAzul {
			width: 265px;
			top: 72px;
			right: -10px;
		}

		.suvinilVetorVazado {
			width: 132px;
			top: 10px;
			right: 0;
		}

		.animSuvinilTextLeft {
			transform: translateX(-70px);
		}

		.animSuvinilCard1 {
			transform: translateX(-70px);
		}

		.animSuvinilCard2 {
			transform: translateX(70px);
		}

		.animSuvinilVector {
			transform: translateX(90px);
		}

		.animSuvinilCelular {
			transform: translateX(-50%) translateY(80px);
		}

		.animSuvinilStat150 {
			transform: translateX(-80px);
		}

		.animSuvinilStat100 {
			transform: translateX(80px);
		}
	}

	@media (max-width: 520px) {
		.suvinilSection {
			padding: 38px 0;
		}

		.suvinilContainer {
			width: calc(100% - 16px);
			height: 430px;
		}

		.suvinilTexto {
			left: 2%;
			max-width: 230px;
			font-size: 10px;
			line-height: 1.35;
		}

		.suvinilStat strong {
			font-size: 34px;
		}

		.suvinilStat span {
			font-size: 9px;
		}

		.suvinilStat150 {
			left: 7%;
			top: 88px;
		}

		.suvinilStat100 {
			right: 10%;
			bottom: 22px;
		}

		.suvinilCelular {
			width: 140px;
			top: 94px;
		}

		.suvinilCard1 {
			width: 72px;
			height: 62px;
			left: 1.5%;
			top: 198px;
		}

		.suvinilCard2 {
			width: 72px;
			height: 62px;
			left: 17%;
			top: 198px;
		}

		.suvinilCard3 {
			width: 72px;
			height: 60px;
			left: 1.5%;
			top: 267px;
		}

		.suvinilCard4 {
			width: 96px;
			height: 60px;
			left: 17%;
			top: 267px;
		}

		.suvinilCard5 {
			width: 95px;
			height: 60px;
			right: 21%;
			top: 140px;
		}

		.suvinilCard6 {
			width: 66px;
			height: 60px;
			right: 1.5%;
			top: 140px;
		}

		.suvinilCard7 {
			width: 78px;
			height: 56px;
			right: 25%;
			top: 207px;
		}

		.suvinilCard8 {
			width: 82px;
			height: 56px;
			right: 1.5%;
			top: 207px;
		}

		.suvinilVectorAzul {
			width: 205px;
			top: 62px;
			right: -8px;
		}

		.suvinilVetorVazado {
			width: 104px;
			top: 8px;
		}
	}
`;

export const CssInstagram = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;

	/* ========================= PARTE 5 - INSTAGRAM ========================= */

	.instagramSection {
		width: 100%;
		background: #77e7ff;
		position: relative;
		overflow: hidden;
		padding: 0 0 80px 0;
		box-sizing: border-box;
	}

	.instagramContainer {
		width: 100%;
		max-width: 1440px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
		padding: 90px 4% 0;
		 min-height: 1120px;
		 z-index: 10
	}

	.instagramVetorVermelho {
		width: 320px;
		height: auto;
		display: block;
		position: absolute;
		left: 0;
		top: 0;
		z-index: 1;
	}

	.instagramDescricao {
		width: 100%;
		max-width: 780px;
		margin: 0 auto 100px;
		position: relative;
		z-index: 3;
		color: #003846;
		font-size: 20px;
		line-height: 1.45;
		font-weight: 500;
		text-align: center;
		letter-spacing: -0.02em;
	}

	.instagramDescricao p {
		margin: 0;
	}

	.instagramGrid {
		width: 100%;
		position: relative;
		z-index: 4;
		display: grid;
		grid-template-columns: repeat(5, 1fr);
		column-gap: 24px;
		row-gap: 44px;
		align-items: start;
	}

	/* ========================= POSTS ========================= */
	/* A div faz a animação no scroll. A imagem faz o hover. */

	.instagramPostBox {
		width: 100%;
		height: auto;
		display: block;
		position: relative;
		z-index: 4;
		box-sizing: border-box;
	}

	.instagramPostImg {
		width: 100%;
		height: auto;
		display: block;
		border-radius: 0;
		object-fit: cover;
		box-sizing: border-box;
		cursor: pointer;
		transform-origin: center center;
		transition:
			transform 0.35s ease,
			filter 0.35s ease;
		will-change: transform, filter;
	}

	.instagramPostBox:hover {
		z-index: 20;
	}

	.instagramPostBox:hover .instagramPostImg {
		transform: rotate(-3deg) scale(1.04);
		filter: drop-shadow(0 16px 18px rgba(0, 0, 0, 0.22));
	}

	.instagramPostBox:nth-child(even):hover .instagramPostImg {
		transform: rotate(3deg) scale(1.04);
	}

	/* Alternância vertical dos posts */
	.instagramPost1,
	.instagramPost3,
	.instagramPost5 {
		margin-top: 0;
	}

	.instagramPost2,
	.instagramPost4 {
		margin-top: 46px;
	}

	.instagramPost6,
	.instagramPost8,
	.instagramPost10 {
		margin-top: 46px;
	}

	.instagramPost7,
	.instagramPost9 {
		margin-top: 0;
	}

	/* ========================= ANIMAÇÕES - INSTAGRAM ========================= */

	.animInstagramVetor {
		opacity: 0;
		transform: translateY(-140px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animInstagramDescricao {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.85s ease 0.3s, transform 0.85s ease 0.3s;
	}

	.animInstagramPostTop {
		opacity: 0;
		transform: translateX(-120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.animInstagramPostBottom {
		opacity: 0;
		transform: translateX(120px);
		transition-property: opacity, transform;
		transition-duration: 0.75s;
		transition-timing-function: ease;
	}

	.instagramPost1 {
		transition-delay: 0.65s;
	}

	.instagramPost2 {
		transition-delay: 0.85s;
	}

	.instagramPost3 {
		transition-delay: 1.05s;
	}

	.instagramPost4 {
		transition-delay: 1.25s;
	}

	.instagramPost5 {
		transition-delay: 1.45s;
	}

	.instagramPost6 {
		transition-delay: 1.75s;
	}

	.instagramPost7 {
		transition-delay: 1.95s;
	}

	.instagramPost8 {
		transition-delay: 2.15s;
	}

	.instagramPost9 {
		transition-delay: 2.35s;
	}

	.instagramPost10 {
		transition-delay: 2.55s;
	}

	.animateInstagram .animInstagramVetor,
	.animateInstagram .animInstagramDescricao {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateInstagram .animInstagramPostTop,
	.animateInstagram .animInstagramPostBottom {
		opacity: 1;
		transform: translate(0, 0);
	}

	/* ========================= RESPONSIVO - INSTAGRAM ========================= */

	@media (max-width: 1550px) {
		.instagramSection {
			padding: 0 0 80px 0;
		}

		.instagramContainer {			
			padding: 82px 3% 0;
			max-width: 1520px;
		}

		.instagramVetorVermelho {
			width: 270px;
		}

		.instagramDescricao {
			max-width: 720px;
			font-size: 18px;
			margin-bottom: 46px;
		}

		.instagramGrid {
			column-gap: 20px;
			row-gap: 40px;
		}

		.instagramPost2,
		.instagramPost4,
		.instagramPost6,
		.instagramPost8,
		.instagramPost10 {
			margin-top: 40px;
		}
	}

	@media (max-width: 1100px) {
		.instagramContainer {
			width: 100%;
			padding: 78px 24px 0;
			    min-height: 820px;
		}

		.instagramVetorVermelho {
			width: 230px;
		}

		.instagramDescricao {
			max-width: 660px;
			font-size: 17px;
			margin-bottom: 40px;
		}

		.instagramGrid {
			column-gap: 16px;
			row-gap: 34px;
		}

		.instagramPost2,
		.instagramPost4,
		.instagramPost6,
		.instagramPost8,
		.instagramPost10 {
			margin-top: 34px;
		}
	}

	@media (max-width: 820px) {
		.instagramSection {
			padding: 0 0 80px 0;
		}

		.instagramContainer {
			padding: 66px 14px 0;
			min-height: 750px;
		}

		.instagramVetorVermelho {
			width: 180px;
		}

		.instagramDescricao {
			max-width: 67%;
			font-size: 15px;
			line-height: 1.4;
			margin-bottom: 80px;
		}

		.instagramGrid {
			grid-template-columns: repeat(4, 1fr);
			column-gap: 12px;
			row-gap: 32px;
			align-items: start;
		}

		.instagramPostHideMobile {
			display: none;
		}

		/* Alternância com 4 posts por linha */
		.instagramPost1,
		.instagramPost3,
		.instagramPost7,
		.instagramPost9 {
			margin-top: 0;
		}

		.instagramPost2,
		.instagramPost4,
		.instagramPost6,
		.instagramPost8 {
			margin-top: 30px;
		}

		.animInstagramVetor {
			transform: translateY(-90px);
		}

		.animInstagramDescricao {
			transform: translateY(-60px);
		}

		.animInstagramPostTop {
			transform: translateX(-70px);
		}

		.animInstagramPostBottom {
			transform: translateX(70px);
		}

		.instagramPostBox:hover .instagramPostImg {
			transform: rotate(-2deg) scale(1.025);
			filter: drop-shadow(0 10px 12px rgba(0, 0, 0, 0.18));
		}

		.instagramPostBox:nth-child(even):hover .instagramPostImg {
			transform: rotate(2deg) scale(1.025);
		}
	}

	@media (max-width: 520px) {
		.instagramSection {
			padding: 0 0 30px 0;
		}

		.instagramContainer {
			padding: 54px 10px 0;
		}

		.instagramVetorVermelho {
			width: 115px;
		}

		.instagramDescricao {
			max-width: 94%;
			font-size: 13px;
			margin-bottom: 22px;
		}

		.instagramGrid {
			column-gap: 8px;
			row-gap: 24px;
		}

		.instagramPost2,
		.instagramPost4,
		.instagramPost6,
		.instagramPost8 {
			margin-top: 22px;
		}

		.instagramContainer {
			width: 100%;
			padding: 78px 24px 0;
			min-height: 485px;
		}

	}

	@media (max-width: 390px) {
		.instagramGrid {
			column-gap: 6px;
			row-gap: 20px;
		}

		.instagramDescricao {
			font-size: 12px;
		}

		.instagramPost2,
		.instagramPost4,
		.instagramPost6,
		.instagramPost8 {
			margin-top: 18px;
		}
	}
`;

export const CssEcom = styled.div`
	width: 100%;
	background: #e90000;
	font-family: "Barlow", sans-serif;
	overflow: visible;
	position: relative;
	z-index: 4;

	/* ========================= PARTE 6 - ECOM ========================= */

	.ecomSection {
		width: 100%;
		background: #e90000;
		position: relative;
		overflow: visible;
		padding: 0;
		box-sizing: border-box;
	}

	.ecomContainer {
		width: 100%;
		max-width: 1440px;
		height: 900px;
		margin: 0 auto;
		position: relative;
		overflow: visible;
		box-sizing: border-box;
	}

	/* ========================= TEXTOS ========================= */

	.ecomTexto {
		position: absolute;
		z-index: 15;
		color: #fff7df;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 600;
		letter-spacing: -0.02em;
	}

	.ecomTexto p {
		margin: 0;
	}

	.ecomTextoTopo {
		width: 100%;
		max-width: 500px;
		left: 11%;
		top: 85px;
		text-align: left;
	}

	.ecomTextoBaixo {
		width: 100%;
		max-width: 510px;
		right: 11%;
		bottom: 82px;
		text-align: center;
	}

	/* ========================= NOTE ========================= */

	.ecomNote {
		width: 620px;
		max-width: 48vw;
		height: auto;
		display: block;
		position: absolute;
		left: 50%;
		top: 250px;
		transform: translateX(-50%);
		z-index: 10;
		filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.25));
	}

	/* ========================= VETORES ========================= */

	.ecomVectorCima {
		width: 800px;
		max-width: 58vw;
		height: auto;
		display: block;
		position: absolute;
		right: -149px;
		top: -283px;
		z-index: 2;
		pointer-events: none;
	}

	.ecomVectorBaixo {
		width: 360px;
		height: auto;
		display: block;
		position: absolute;
		left: 0;
		bottom: -109px;
		z-index: 12;
		pointer-events: none;
	}

	.ecomVetorEsquerdo {
		width: 130px;
		height: auto;
		display: block;
		position: absolute;
		left: 70px;
		bottom: -90px;
		z-index: 13;
		pointer-events: none;
	}

	/* ========================= NÚMEROS ========================= */

	.ecomStat {
		position: absolute;
		z-index: 14;
		display: flex;
		flex-direction: column;
		align-items: center;
		line-height: 1;
	}

	.ecomStat strong {
		display: block;
		color: #77e7ff;
		font-size: 104px;
		line-height: 0.88;
		font-weight: 800;
		letter-spacing: -0.08em;
	}

	.ecomStat span {
		display: block;
		margin-top: 16px;
		color: #fff7df;
		font-size: 20px;
		line-height: 1.2;
		font-weight: 400;
		text-align: center;
		letter-spacing: -0.04em;
	}

	.ecomStatLeft {
		left: 4%;
		top: 395px;
	}

	.ecomStatRight {
		right: 6%;
		top: 395px;
	}

	/* ========================= ANIMAÇÕES ========================= */

	.animEcomTextoLeft {
		opacity: 0;
		transform: translateX(-130px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animEcomTextoBottom {
		opacity: 0;
		transform: translateY(110px);
		transition: opacity 0.85s ease 0.2s, transform 0.85s ease 0.2s;
	}

	.animEcomVectorCima {
		opacity: 0;
		transform: translateY(-190px);
		transition: opacity 0.9s ease 0.45s, transform 0.9s ease 0.45s;
	}

	.animEcomVectorBaixo {
		opacity: 0;
		transform: translateX(-170px);
		transition: opacity 0.9s ease 0.75s, transform 0.9s ease 0.75s;
	}

	.animEcomVetorEsquerdo {
		opacity: 0;
		transform: translateX(-120px);
		transition: opacity 0.85s ease 1.05s, transform 0.85s ease 1.05s;
	}

	.animEcomNote {
		opacity: 0;
		transform: translateX(-50%) translateY(140px);
		transition: opacity 0.95s ease 1.25s, transform 0.95s ease 1.25s;
	}

	.animEcomStatLeft {
		opacity: 0;
		transform: translateX(-150px);
		transition: opacity 0.85s ease 1.9s, transform 0.85s ease 1.9s;
	}

	.animEcomStatRight {
		opacity: 0;
		transform: translateX(150px);
		transition: opacity 0.85s ease 2.05s, transform 0.85s ease 2.05s;
	}

	.animateEcom .animEcomTextoLeft,
	.animateEcom .animEcomTextoBottom,
	.animateEcom .animEcomVectorCima,
	.animateEcom .animEcomVectorBaixo,
	.animateEcom .animEcomVetorEsquerdo,
	.animateEcom .animEcomStatLeft,
	.animateEcom .animEcomStatRight {
		opacity: 1;
		transform: translate(0, 0);
	}

	.animateEcom .animEcomNote {
		opacity: 1;
		transform: translateX(-50%) translateY(0);
	}

	/* ========================= RESPONSIVO ========================= */


	@media (max-width: 1680px) {
		.ecomVectorCima {
			width: 670px;			
			right: -60px;
			top: -236px;	
		}
	}

	@media (max-width: 1440px) {
		.ecomContainer {
			max-width: 1180px;
			height: 760px;
		}

		.ecomTexto {
			font-size: 17px;
		}

		.ecomTextoTopo {
			max-width: 470px;
			left: 11%;
			top: 72px;
		}

		.ecomTextoBaixo {
			max-width: 470px;
			right: 9%;
			bottom: 70px;
		}

		.ecomNote {
			width: 560px;
			top: 215px;
		}

		.ecomVectorCima {
			width: 539px;
			right: -12px;
			top: -190px;
		}	

		.ecomStat strong {
			font-size: 90px;
		}

		.ecomStat span {
			font-size: 18px;
		}

		.ecomStatLeft {
			left: 3.5%;
			top: 340px;
		}

		.ecomStatRight {
			right: 5%;
			top: 340px;
		}
	}

	@media (max-width: 1100px) {
		.ecomContainer {
			height: 670px;
		}

		.ecomTexto {
			font-size: 15px;
		}

		.ecomTextoTopo {
			max-width: 390px;
			left: 8%;
			top: 60px;
		}

		.ecomTextoBaixo {
			max-width: 390px;
			right: 7%;
			bottom: 58px;
		}

		.ecomNote {
			width: 425px;
			max-width: 50vw;
			top: 200px;
		}

		.ecomVectorCima {
			width: 468px;
			max-width: 60vw;
			top: -165px;
			right: 0
		}

		.ecomVectorBaixo {
			width: 280px;		
		}

		.ecomVetorEsquerdo {
			width: 100px;
		}

		.ecomStat strong {
			font-size: 72px;
		}

		.ecomStat span {
			margin-top: 12px;
			font-size: 15px;
		}

		.ecomStatLeft {
			left: 3%;
			top: 315px;
		}

		.ecomStatRight {
			right: 4%;
			top: 315px;
		}
	}

	@media (max-width: 820px) {
		.ecomContainer {
			height: 640px;
		}

		.ecomTexto {
			font-size: 13px;
			line-height: 1.38;
		}

		.ecomTextoTopo {
			max-width: 310px;
			left: 24px;
			top: 42px;
		}

		.ecomTextoBaixo {
			max-width: 300px;
			right: 24px;
			bottom: 42px;
		}

		.ecomNote {
			width: 410px;
			max-width: 50vw;
			top: 190px;
		}

		.ecomVectorCima {
			width: 230px;
			max-width: 60vw;
			top: -83px;
			right: 35px;
		}

		.ecomVectorBaixo {
			width: 230px;
			left: -20px;
			bottom: -70px;
		}

		.ecomVetorEsquerdo {
			width: 80px;
			left: 20px;
			bottom: -50px;
		}

		.ecomStat strong {
			font-size: 54px;
		}

		.ecomStat span {
			font-size: 12px;
			max-width: 130px;
		}

		.ecomStatLeft {
			left: 22px;
			top: 335px;
		}

		.ecomStatRight {
			right: 22px;
			top: 335px;
		}

		.animEcomTextoLeft {
			transform: translateX(-80px);
		}

		.animEcomTextoBottom {
			transform: translateY(80px);
		}

		.animEcomVectorCima {
			transform: translateY(-120px);
		}

		.animEcomVectorBaixo {
			transform: translateX(-100px);
		}

		.animEcomVetorEsquerdo {
			transform: translateX(-80px);
		}

		.animEcomNote {
			transform: translateX(-50%) translateY(90px);
		}

		.animEcomStatLeft {
			transform: translateX(-90px);
		}

		.animEcomStatRight {
			transform: translateX(90px);
		}
	}

	@media (max-width: 520px) {
		.ecomContainer {
			height: 610px;
		}

		.ecomTexto {
			font-size: 11px;
			line-height: 1.35;
		}

		.ecomTextoTopo {
			max-width: 245px;
			left: 18px;
			top: 75px;
		}

		.ecomTextoBaixo {
			max-width: 245px;
			right: 18px;
			bottom: 34px;
		}

		.ecomNote {
			width: 270px;
			max-width: 80vw;
			top: 160px;
		}

		.ecomVectorCima {
		     width: 145px;
			right: 6px;
			top: -52px;
		}

		.ecomVectorBaixo {
			width: 130px;
			left: -30px;
			bottom: -40px;
		}

		.ecomVetorEsquerdo {
			width: 52px;
			left: 5px;
			bottom: -30px;
		}

		.ecomStat strong {
			font-size: 38px;
		}

		.ecomStat span {
			margin-top: 8px;
			font-size: 10px;
			max-width: 95px;
		}

		.ecomStatLeft {
			left: 60px;
        	top: 380px;
		}

		.ecomStatRight {
			right: 60px;
			top: 380px;
		}
	}

	@media (max-width: 390px) {
		.ecomContainer {
			height: 570px;
		}

		.ecomTextoTopo {
			max-width: 220px;
		}

		.ecomTextoBaixo {
			max-width: 220px;
		}	

	

		.ecomStat strong {
			font-size: 34px;
		}

		.ecomStatLeft {
			top: 370px;
		}

		.ecomStatRight {
			top: 370px;
		}
	}
`;

export const CssFim = styled.div`
	width: 100%;
	background: #fff7df;
	font-family: "Barlow", sans-serif;
	overflow: hidden;
	position: relative;

	/* ========================= PARTE 7 - FIM ========================= */

	.fimSection {
		width: 100%;
		background: #fff7df;
		position: relative;
		overflow: hidden;
		padding: 0 0 95px;
		box-sizing: border-box;
	}

	.fimContainer {
		width: 100%;
		max-width: 1440px;
		min-height: 760px;
		margin: 0 auto;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;
		padding: 78px 0 0;
	}

	.fimTexto {
		width: 100%;
		max-width: 820px;
		margin: 0 auto 66px;
		position: relative;
		z-index: 5;
		color: #111;
		font-size: 18px;
		line-height: 1.45;
		font-weight: 500;
		text-align: center;
		letter-spacing: -0.02em;
		padding: 0 24px;
		box-sizing: border-box;
	}

	.fimTexto p {
		margin: 0;
	}

	.fimVetor {
		width: 360px;
		height: auto;
		display: block;
		position: absolute;
		right: 0;
		top: -32px;
		z-index: 2;
		pointer-events: none;
	}

	.fimFotos {
		width: 100%;
		position: relative;
		z-index: 4;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 10px;
		align-items: stretch;
	}

	.fimFoto {
		width: 100%;
		height: 700px;
		display: block;
		object-fit: cover;
		border-radius: 4px;
		box-sizing: border-box;
	}

	/* ========================= ANIMAÇÕES - FIM ========================= */

	.animFimTexto {
		opacity: 0;
		transform: translateY(-90px);
		transition: opacity 0.85s ease, transform 0.85s ease;
	}

	.animFimVetor {
		opacity: 0;
		transform: translateY(-150px);
		transition: opacity 0.9s ease 0.25s, transform 0.9s ease 0.25s;
	}

	.animFimFoto {
		opacity: 0;
		transform: translateX(-120px);
		transition-property: opacity, transform;
		transition-duration: 0.8s;
		transition-timing-function: ease;
	}

	.fimFoto1 {
		transition-delay: 0.55s;
	}

	.fimFoto2 {
		transition-delay: 0.8s;
	}

	.fimFoto3 {
		transition-delay: 1.05s;
	}

	.animateFim .animFimTexto,
	.animateFim .animFimVetor,
	.animateFim .animFimFoto {
		opacity: 1;
		transform: translate(0, 0);
	}

	/* ========================= RESPONSIVO ========================= */

	@media (max-width: 1440px) {
		.fimContainer {
			max-width: 1180px;
			min-height: 690px;
			padding-top: 70px;
		}

		.fimTexto {
			max-width: 790px;
			font-size: 17px;
			margin-bottom: 58px;
		}

		.fimVetor {
			width: 300px;
			top: -28px;
		}

		.fimFoto {
			height: 610px;
		}
	}

	@media (max-width: 1100px) {
		.fimSection {
			padding-bottom: 80px;
		}

		.fimContainer {
			width: 100%;
			min-height: 620px;
			padding-top: 62px;
		}

		.fimTexto {
			max-width: 740px;
			font-size: 16px;
			margin-bottom: 50px;
		}

		.fimVetor {
			width: 260px;
			right: -20px;
			top: -20px;
		}

		.fimFotos {
			gap: 8px;
		}

		.fimFoto {
			height: 540px;
		}
	}

	@media (max-width: 820px) {
		.fimSection {
			padding-bottom: 65px;
		}

		.fimContainer {
			min-height: 560px;
			padding-top: 54px;
		}

		.fimTexto {
			max-width: 82%;
			font-size: 14px;
			line-height: 1.4;
			margin-bottom: 42px;
			padding: 0;
		}

		.fimVetor {
			width: 210px;
			right: -44px;
			top: -12px;
		}

		.fimFotos {
			gap: 7px;
		}

		.fimFoto {
			height: 450px;
			border-radius: 3px;
		}

		.animFimTexto {
			transform: translateY(-65px);
		}

		.animFimVetor {
			transform: translateY(-100px);
		}

		.animFimFoto {
			transform: translateX(-80px);
		}
	}

	@media (max-width: 520px) {
		.fimSection {
			padding-bottom: 50px;
		}

		.fimContainer {
			min-height: 520px;
			padding-top: 46px;
		}

		.fimTexto {
			max-width: 88%;
			font-size: 12px;
			line-height: 1.38;
			margin-bottom: 34px;
		}

		.fimVetor {
			width: 155px;
			right: -42px;
			top: -8px;
		}

		.fimFotos {
			gap: 5px;
		}

		.fimFoto {
			height: 390px;
			border-radius: 2px;
		}
	}

	@media (max-width: 390px) {
		.fimContainer {
			min-height: 480px;
		}

		.fimTexto {
			font-size: 11px;
			margin-bottom: 28px;
		}

		.fimVetor {
			width: 135px;
			right: -38px;
		}

		.fimFotos {
			gap: 4px;
		}

		.fimFoto {
			height: 340px;
		}
	}
`;